import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UiStorage } from '../../lib/services/ui-storage'
import { AovCalculationService } from '../../lib/services/aov-calculation-service';

@Component({
    standalone: false,
    selector: 'app-advies',
    templateUrl: './advies.component.html',
    styleUrls: ['./advies.component.css']
})
export class AdviesComponent implements OnInit {
    @Input() model : any;
    style: string;

    constructor(private _router: Router, private _storage: UiStorage, private _calculator: AovCalculationService,
        private _spinner: NgxSpinnerService
            ) {
        this.model = _storage.load() || {};
        this.style = this.model.style.toLowerCase();
    }

    private showSpinner(
        timeoutInMilliSeconds: number = 1000*3600 // 1 hour default timeout
    ) {
        this._spinner.show();
        setTimeout(() => {
            this.hideSpinner();
        }, timeoutInMilliSeconds);
    }

    private hideSpinner() {
        this._spinner.hide();
    }

    public onPrevious() {
        this._storage.save(this.model);
        this._router.navigate(['/verzekerde']);
    }

    public onNext() {
        this.showSpinner();
        try {
            this._storage.save(this.model);
            this._calculator.sendLead(this.getMergedAfd(), v => {
                this._router.navigate(['/bevestiging']);
                this.hideSpinner();
            }, error => {
                this.hideSpinner();
            });
        } catch (ex) {
            this.hideSpinner();
        }
    }

    private getMergedAfd(): any {
        const model = this._storage.load(),
            afd = this._storage.loadAfd(),
            pp = afd.Contractdocument.PP,
            vp = pp.VP,
            vz = pp.VZ;

        vp.VP_ANAAM = vz.VZ_ANAAM = model.name;
        vp.VP_VOORV = vz.VZ_VOORV = model.prefix;
        vp.VP_VOORL = vz.VZ_VOORL = model.initials;
        vp.VP_GESLACH = vz.VZ_GESLACH = model.gender;
        vp.VP_EMAIL = vz.VZ_EMAIL = model.email;
        vp.VP_TELNUM = vz.VZ_TELNUM = model.telephoneNumber;
        vp.VP_AANNUM = vz.VZ_AANNUM = model.clientNumber;

        return afd;
    }

    ngOnInit() {
    }

}
